import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'

const ValueWrapper = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

type Props = React.ComponentProps<typeof components.SingleValue>

function SingleValue({ children, ...props }: Props) {
  return (
    <components.SingleValue {...props}>
      <ValueWrapper>{children}</ValueWrapper>
    </components.SingleValue>
  )
}

export default SingleValue
